import { createFileRoute } from '@tanstack/react-router'
import { AcceptInvitationPage } from '@/components/accept-invitation-page'

interface AcceptInvitationSearch {
  token: string
}

export const Route = createFileRoute('/accept-invitation')({
  validateSearch: (search: Record<string, unknown>): AcceptInvitationSearch => {
    return {
      token: (search.token as string) || '',
    }
  },
  component: AcceptInvitationRoute,
})

function AcceptInvitationRoute() {
  const { token } = Route.useSearch()
  return <AcceptInvitationPage token={token} />
}
